import { createIcon } from '../utils';

export const HeartIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99543 3.42388C6.66253 1.8656 4.43983 1.44643 2.7698 2.87334C1.09976 4.30026 0.864645 6.68598 2.17613 8.3736C3.26654 9.77674 6.56651 12.7361 7.64807 13.6939C7.76907 13.801 7.82957 13.8546 7.90014 13.8757C7.96174 13.8941 8.02913 13.8941 8.09073 13.8757C8.1613 13.8546 8.2218 13.801 8.3428 13.6939C9.42435 12.7361 12.7243 9.77674 13.8147 8.3736C15.1262 6.68598 14.9198 4.28525 13.2211 2.87334C11.5223 1.46144 9.32834 1.8656 7.99543 3.42388Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'HeartIcon' },
);
